var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page", attrs: { id: "tabSettlement" } },
    [
      _vm.balanceVisible
        ? _c(
            "div",
            {
              staticClass: "va-row mb-5",
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
              },
            },
            [
              _c(
                "div",
                { staticClass: "flex md2 xs12" },
                [
                  _c("vuestic-widget", { staticClass: "info-widget" }, [
                    _c(
                      "div",
                      { staticClass: "info-widget-inner" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "w-title mb-2",
                            staticStyle: { "min-height": "80px" },
                          },
                          [
                            _c("h5", [
                              _vm._v(
                                _vm._s(_vm._f("translate")("t.totalAmount"))
                              ),
                            ]),
                            _c("small", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("translate")("t.processingFeeIncluded")
                                )
                              ),
                            ]),
                          ]
                        ),
                        _vm._l(_vm.totalAmount, function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "w-content" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.getJsonKey(item)) +
                                    "    " +
                                    _vm._s(_vm.getJsonValue(item))
                                ),
                              ]),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex md2 xs12" },
                [
                  _c("vuestic-widget", { staticClass: "info-widget" }, [
                    _c(
                      "div",
                      { staticClass: "info-widget-inner" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "w-title mb-2",
                            staticStyle: { "min-height": "80px" },
                          },
                          [
                            _c("h5", [
                              _vm._v(
                                _vm._s(_vm._f("translate")("t.netIncome"))
                              ),
                            ]),
                            _c("small", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("translate")("t.processingFeeDeducted")
                                )
                              ),
                            ]),
                          ]
                        ),
                        _vm._l(_vm.netIncome, function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "w-content" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.getJsonKey(item)) +
                                    "    " +
                                    _vm._s(_vm.getJsonValue(item))
                                ),
                              ]),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex md2 xs12" },
                [
                  _c("vuestic-widget", { staticClass: "info-widget" }, [
                    _c(
                      "div",
                      { staticClass: "info-widget-inner" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "w-title mb-2",
                            staticStyle: { "min-height": "80px" },
                          },
                          [
                            _c("h5", [
                              _vm._v(_vm._s(_vm._f("translate")("t.balance"))),
                            ]),
                            _c("small", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("translate")("t.processingFeeDeducted")
                                )
                              ),
                            ]),
                          ]
                        ),
                        _vm._l(_vm.balance, function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "w-content" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.getJsonKey(item)) +
                                    "    " +
                                    _vm._s(_vm.getJsonValue(item))
                                ),
                              ]),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                ],
                1
              ),
              _vm.settlementAmount
                ? _c(
                    "div",
                    { staticClass: "flex md2 xs12" },
                    [
                      _c("vuestic-widget", { staticClass: "info-widget" }, [
                        _c(
                          "div",
                          { staticClass: "info-widget-inner" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "w-title mb-2",
                                staticStyle: { "min-height": "80px" },
                              },
                              [
                                _c("h5", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")("t.settlementAmount")
                                    )
                                  ),
                                ]),
                                _c("small", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "t.processingFeeDeducted"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._l(
                              _vm.settlementAmount,
                              function (item, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "w-content" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.getJsonKey(item)) +
                                          "    " +
                                          _vm._s(_vm.getJsonValue(item))
                                      ),
                                    ]),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.payout
                ? _c(
                    "div",
                    {
                      staticClass: "flex md2 xs12",
                      staticStyle: { position: "relative" },
                    },
                    [
                      _c("vuestic-widget", { staticClass: "info-widget" }, [
                        _c(
                          "div",
                          { staticClass: "info-widget-inner" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "w-title mb-2",
                                staticStyle: { "min-height": "80px" },
                              },
                              [
                                _c("h5", [
                                  _vm._v(
                                    _vm._s(_vm._f("translate")("t.withdraw"))
                                  ),
                                ]),
                                _c("small", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "t.processingFeeDeducted"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._l(_vm.payout, function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "w-content" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.getJsonKey(item)) +
                                        "    " +
                                        _vm._s(_vm.getJsonValue(item))
                                    ),
                                  ]),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                        _c("div", { staticClass: "flex va-row mt-2" }, [
                          _vm.isShowPayout || _vm.isShowBank || _vm.isShowVA
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary btn-micro",
                                  staticStyle: {
                                    position: "absolute",
                                    left: "0",
                                  },
                                  on: { click: _vm.createWithdraw },
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("translate")("t.createWithdraw")
                                      )
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.reserveArray
                ? _c(
                    "div",
                    { staticClass: "flex md2 xs12" },
                    [
                      _c("vuestic-widget", { staticClass: "info-widget" }, [
                        _c(
                          "div",
                          { staticClass: "info-widget-inner" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "w-title mb-2",
                                staticStyle: { "min-height": "80px" },
                              },
                              [
                                _c("h5", [
                                  _vm._v(
                                    _vm._s(_vm._f("translate")("t.reserve"))
                                  ),
                                ]),
                                _c("small", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "t.processingFeeDeducted"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._l(_vm.reserveArray, function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "w-content" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.getJsonKey(item)) +
                                        "    " +
                                        _vm._s(_vm.getJsonValue(item))
                                    ),
                                  ]),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm.isShowListPayout || _vm.isShowListBank || _vm.isShowListVA
        ? _c(
            "tabs",
            {
              ref: "financeTabs",
              attrs: { options: { useUrlFragment: false } },
              on: { clicked: _vm.tabClicked, changed: _vm.tabChanged },
            },
            [
              _vm.isShowListPayout
                ? _c(
                    "tab",
                    {
                      attrs: {
                        name: _vm.$t("t.payoutHistory"),
                        id: "payout-history",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "page invoice-wrap",
                          attrs: { id: "tabPayoutHistory" },
                        },
                        [
                          _c("section", { staticClass: "flex md12 xs12" }, [
                            _c(
                              "div",
                              { staticClass: "flex md12 xs12" },
                              [
                                _c("label", { staticClass: "select-title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")("t.createDate")
                                    ) + "："
                                  ),
                                ]),
                                _c("date-picker", {
                                  staticStyle: { width: "240px" },
                                  attrs: {
                                    range: "",
                                    format: _vm.momentFormat,
                                    placeholder: _vm.$t(
                                      "finance.dateRangePlaceholder"
                                    ),
                                  },
                                  model: {
                                    value: _vm.payoutHistory.dates,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.payoutHistory, "dates", $$v)
                                    },
                                    expression: "payoutHistory.dates",
                                  },
                                }),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "account-statement",
                                    attrs: { type: "success" },
                                    on: { click: _vm.queryPayoutHistory },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("basic.button.search"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "dataGrid-report" },
                              [
                                _c(
                                  "el-table",
                                  {
                                    staticClass: "dataGrid-report-table",
                                    attrs: {
                                      data: _vm.payoutHistory.tableData,
                                      "tooltip-effect": "light",
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        "min-width": "240",
                                        prop: "withdraw_id",
                                        label: _vm.$t("t.id"),
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        "min-width": "150",
                                        prop: "desc",
                                        label: _vm.$t("t.remark"),
                                        "show-overflow-tooltip": "",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        "min-width": "100",
                                        prop: "request_currency",
                                        label: _vm.$t("t.currency"),
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        "min-width": "150",
                                        prop: "request_amount",
                                        label: _vm.$t("tables.listing.amount"),
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        "min-width": "150",
                                        prop: "create_time",
                                        label: _vm.$t(
                                          "tables.listing.recurring_create_time"
                                        ),
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "status",
                                        label: _vm.$t("tables.listing.status"),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.payoutHistory.total >
                                          _vm.payoutHistory.pageSize,
                                        expression:
                                          "payoutHistory.total > payoutHistory.pageSize",
                                      },
                                    ],
                                    staticClass: "block",
                                  },
                                  [
                                    _c("pagination", {
                                      attrs: {
                                        total: _vm.payoutHistory.total,
                                        layout:
                                          "total, sizes, prev, pager, next, jumper",
                                        background: "",
                                        "page-size": _vm.payoutHistory.pageSize,
                                        page: _vm.payoutHistory.pageNum,
                                        limit: _vm.payoutHistory.pageSize,
                                        "page-sizes": [10, 50, 100],
                                      },
                                      on: {
                                        "update:page": function ($event) {
                                          return _vm.$set(
                                            _vm.payoutHistory,
                                            "pageNum",
                                            $event
                                          )
                                        },
                                        "update:limit": function ($event) {
                                          return _vm.$set(
                                            _vm.payoutHistory,
                                            "pageSize",
                                            $event
                                          )
                                        },
                                        pagination: _vm.queryPayoutHistory,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.isShowListBank
                ? _c(
                    "tab",
                    {
                      attrs: {
                        name: _vm.$t("finance.bankHistory"),
                        id: "bank-history",
                      },
                    },
                    [_c("bank-withdrawal", { ref: "bankWithdrawalComponent" })],
                    1
                  )
                : _vm._e(),
              _vm.isShowListVA
                ? _c(
                    "tab",
                    {
                      attrs: {
                        name: _vm.$t("finance.vaWalletHistory"),
                        id: "va-wallet-history",
                      },
                    },
                    [_c("virtual-account", { ref: "virtualAccountComponent" })],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "vuestic-modal",
        {
          ref: "withdraw",
          staticStyle: { height: "100%", width: "60vw" },
          attrs: {
            show: _vm.withdrawDialogVisible,
            okText: _vm._f("translate")("modal.confirm2"),
            okClass: "btn btn-primary btn-micro",
            cancelClass: "btn btn-secondary btn-micro",
            cancelText: _vm._f("translate")("modal.cancel2"),
            alignModal: "",
            large: true,
          },
          on: {
            "update:show": function ($event) {
              _vm.withdrawDialogVisible = $event
            },
          },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("t.withdraw"))),
          ]),
          _c(
            "tabs",
            {
              ref: "withdrawTabs",
              attrs: { options: { useUrlFragment: false } },
              on: {
                clicked: _vm.withdrawTabClicked,
                changed: _vm.withdrawTabClicked,
              },
            },
            [
              _vm.isShowPayout
                ? _c(
                    "tab",
                    {
                      attrs: {
                        name: _vm.$t("finance.toPayout"),
                        id: "to-payout",
                      },
                    },
                    [
                      _c("form", { staticStyle: { padding: "10px 20px" } }, [
                        _c("div", { staticClass: "va-row" }, [
                          _c("div", { staticClass: "flex xs12 md12" }, [
                            _c("fieldset", { staticClass: "withdraw-modal" }, [
                              _c("div", { staticClass: "info-group" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group with-icon-right",
                                    class: {
                                      "has-error": _vm.initCurrencyVaild,
                                      valid: _vm.isCurrencyValid("currency"),
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group" },
                                      [
                                        _c("vuestic-kyc-select", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'",
                                            },
                                          ],
                                          attrs: {
                                            id: "currencyInput",
                                            name: "currency",
                                            "data-vv-as": "Currency",
                                            required: "",
                                            label: _vm.$t("t.currency") + "：",
                                            "option-key": "label",
                                            options: _vm.currencies,
                                            autocomplete: "off",
                                          },
                                          on: {
                                            input: (val) => {
                                              _vm.currencyStatus = !val
                                                ? true
                                                : false
                                              _vm.generateExchangeRate()
                                              _vm.updateArrivedCurrencyOption(
                                                val
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.withdrawData.currency,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.withdrawData,
                                                "currency",
                                                $$v
                                              )
                                            },
                                            expression: "withdrawData.currency",
                                          },
                                        }),
                                        _c("i", {
                                          staticClass:
                                            "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                        }),
                                        _c("i", {
                                          staticClass:
                                            "fa icon-right input-icon",
                                        }),
                                        _c(
                                          "small",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.initCurrencyVaild,
                                                expression: "initCurrencyVaild",
                                              },
                                            ],
                                            staticClass: "help text-danger",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errors.first("currency")
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _c("div", { staticClass: "info-group-space" }),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group with-icon-right withdraw-to-close",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group" },
                                      [
                                        _c("vuestic-kyc-select", {
                                          attrs: {
                                            disabled: true,
                                            name: "withdrawTo",
                                            "data-vv-as": "Withdraw to",
                                            label: `${_vm.$t(
                                              "t.withdrawTo"
                                            )}：`,
                                            "option-key": "label",
                                            options: _vm.withdrawToOption,
                                            autocomplete: "off",
                                          },
                                          on: { input: _vm.withdrawToChange },
                                          model: {
                                            value: _vm.withdrawTo,
                                            callback: function ($$v) {
                                              _vm.withdrawTo = $$v
                                            },
                                            expression: "withdrawTo",
                                          },
                                        }),
                                        _c("i", {
                                          staticClass:
                                            "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                        }),
                                        _c("i", {
                                          staticClass:
                                            "fa icon-right input-icon",
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "info-group" }, [
                                _vm.isBank
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group with-icon-right",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.settlementFee,
                                                  expression: "settlementFee",
                                                },
                                              ],
                                              attrs: {
                                                name: "settlementFee",
                                                "data-vv-as": "Settlement Fee",
                                                autocomplete: "off",
                                                disabled: true,
                                              },
                                              domProps: {
                                                value: _vm.settlementFee,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.settlementFee =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-check valid-icon icon-right input-icon",
                                            }),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "control-label",
                                                attrs: { for: "settlementFee" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("translate")(
                                                      "t.settlementFee"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c("i", { staticClass: "bar" }),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                !_vm.isBank
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group with-icon-right withdraw-to-close",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-group with-icon-right",
                                            class: {
                                              "has-error":
                                                _vm.initPayoutAccounts,
                                              valid:
                                                _vm.isPayoutAccountsValid(
                                                  "payoutAccounts"
                                                ),
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "input-group" },
                                              [
                                                _c("vuestic-kyc-select", {
                                                  attrs: {
                                                    name: "Payout Accounts",
                                                    "data-vv-as":
                                                      "Payout Accounts",
                                                    label:
                                                      _vm.$t(
                                                        "finance.payoutAccounts"
                                                      ) + "：",
                                                    "option-key":
                                                      "account_name",
                                                    "option-value":
                                                      "account_id",
                                                    options:
                                                      _vm.payoutAccountsOptions,
                                                    autocomplete: "off",
                                                  },
                                                  on: {
                                                    input: (val) => {
                                                      _vm.payoutAccountsStatus =
                                                        !val ? true : false
                                                      _vm.payoutAccountsChange(
                                                        val
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: _vm.payoutAccounts,
                                                    callback: function ($$v) {
                                                      _vm.payoutAccounts = $$v
                                                    },
                                                    expression:
                                                      "payoutAccounts",
                                                  },
                                                }),
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                                }),
                                                _c("i", {
                                                  staticClass:
                                                    "fa icon-right input-icon",
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.initPayoutAccounts,
                                                        expression:
                                                          "initPayoutAccounts",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "help text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.errors.first(
                                                          "payoutAccounts"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c("div", { staticClass: "info-group-space" }),
                                _vm.isBank
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group with-icon-right",
                                        class: {
                                          "has-error": _vm.errors.has("amount"),
                                          valid: _vm.isFormFieldValid("amount"),
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.withdrawData.amount,
                                                  expression:
                                                    "withdrawData.amount",
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'",
                                                },
                                              ],
                                              attrs: {
                                                name: "amount",
                                                "data-vv-as": "Amount",
                                                autocomplete: "off",
                                                type: "text",
                                                required: "",
                                              },
                                              domProps: {
                                                value: _vm.withdrawData.amount,
                                              },
                                              on: {
                                                input: [
                                                  function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.withdrawData,
                                                      "amount",
                                                      $event.target.value
                                                    )
                                                  },
                                                  _vm.changeAmountValue,
                                                ],
                                              },
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-check valid-icon icon-right input-icon",
                                            }),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "control-label",
                                                attrs: { for: "amount" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("translate")(
                                                      "t.amount"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c("i", { staticClass: "bar" }),
                                            _c(
                                              "small",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.errors.has("amount"),
                                                    expression:
                                                      "errors.has('amount')",
                                                  },
                                                ],
                                                staticClass: "help text-danger",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.errors.first("amount")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                !_vm.isBank
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group with-icon-right withdraw-to-close",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-group with-icon-right",
                                            class: {
                                              "has-error":
                                                _vm.initArrivedCurrency,
                                              valid:
                                                _vm.isArrivedCurrencyValid(
                                                  "arrivedCurrency"
                                                ),
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "input-group" },
                                              [
                                                _c("vuestic-kyc-select", {
                                                  attrs: {
                                                    name: "arrivedCurrency",
                                                    "data-vv-as":
                                                      "Arrived Currency",
                                                    label:
                                                      _vm.$t(
                                                        "finance.arrivedCurrency"
                                                      ) + "：",
                                                    options:
                                                      _vm.arrivedCurrencyOption,
                                                    autocomplete: "off",
                                                  },
                                                  on: {
                                                    input: (val) => {
                                                      _vm.arrivedCurrencyStatus =
                                                        !val ? true : false
                                                      _vm.arrivedCurrencyChange()
                                                    },
                                                  },
                                                  model: {
                                                    value: _vm.arrivedCurrency,
                                                    callback: function ($$v) {
                                                      _vm.arrivedCurrency = $$v
                                                    },
                                                    expression:
                                                      "arrivedCurrency",
                                                  },
                                                }),
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                                }),
                                                _c("i", {
                                                  staticClass:
                                                    "fa icon-right input-icon",
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.initArrivedCurrency,
                                                        expression:
                                                          "initArrivedCurrency",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "help text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.errors.first(
                                                          "arrivedCurrency"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              !_vm.isBank
                                ? _c("div", { staticClass: "info-group" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group with-icon-right",
                                        class: {
                                          "has-error": _vm.errors.has("amount"),
                                          valid: _vm.isFormFieldValid("amount"),
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.withdrawData.amount,
                                                  expression:
                                                    "withdrawData.amount",
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'",
                                                },
                                              ],
                                              attrs: {
                                                name: "amount",
                                                "data-vv-as": "Amount",
                                                autocomplete: "off",
                                                type: "text",
                                                required: "",
                                              },
                                              domProps: {
                                                value: _vm.withdrawData.amount,
                                              },
                                              on: {
                                                change: _vm.amountChange,
                                                input: [
                                                  function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.withdrawData,
                                                      "amount",
                                                      $event.target.value
                                                    )
                                                  },
                                                  _vm.changeAmountValue,
                                                ],
                                              },
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-check valid-icon icon-right input-icon",
                                            }),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "control-label",
                                                attrs: { for: "amount" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("translate")(
                                                      "t.amount"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c("i", { staticClass: "bar" }),
                                            _c(
                                              "small",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.errors.has("amount"),
                                                    expression:
                                                      "errors.has('amount')",
                                                  },
                                                ],
                                                staticClass: "help text-danger",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.errors.first("amount")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c("div", {
                                      staticClass: "info-group-space",
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group with-icon-right",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.arrivedAmount,
                                                  expression: "arrivedAmount",
                                                },
                                              ],
                                              attrs: {
                                                name: "arrivedAmount",
                                                "data-vv-as": "Arrived Amount",
                                                autocomplete: "off",
                                                disabled: true,
                                              },
                                              domProps: {
                                                value: _vm.arrivedAmount,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.arrivedAmount =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-check valid-icon icon-right input-icon",
                                            }),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "control-label",
                                                attrs: { for: "arrivedAmount" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "finance.arrivedAmount"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c("i", { staticClass: "bar" }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.isBank,
                                      expression: "!isBank",
                                    },
                                  ],
                                  staticClass: "info-group",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group with-icon-right",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.exchangeRate,
                                                expression: "exchangeRate",
                                              },
                                            ],
                                            attrs: {
                                              name: "exchangeRate",
                                              "data-vv-as": "exchangeRate",
                                              autocomplete: "off",
                                              disabled: true,
                                            },
                                            domProps: {
                                              value: _vm.exchangeRate,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.exchangeRate =
                                                  $event.target.value
                                              },
                                            },
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-check valid-icon icon-right input-icon",
                                          }),
                                          _c(
                                            "label",
                                            {
                                              staticClass: "control-label",
                                              attrs: { for: "exchangeRate" },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("finance.exchangeRate")
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "light",
                                                content:
                                                  "According to local regulations we need to take the funds outside the territory and bring them back for local payouts, because of that the available balance in local currency needs to be converted into USD, then back to the local currency. And the FX is applied during the conversion.",
                                                placement: "right",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-question",
                                              }),
                                            ]
                                          ),
                                          _c("i", { staticClass: "bar" }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c("div", { staticClass: "info-group" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group with-icon-right",
                                    class: {
                                      "has-error": _vm.errors.has("remark"),
                                      valid: _vm.isFormFieldValid("remark"),
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "input-group" }, [
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.withdrawData.remark,
                                            expression: "withdrawData.remark",
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'",
                                          },
                                        ],
                                        attrs: {
                                          name: "remark",
                                          "data-vv-as": "Remark",
                                          autocomplete: "off",
                                          maxlength: "200",
                                          required: "",
                                        },
                                        domProps: {
                                          value: _vm.withdrawData.remark,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.withdrawData,
                                              "remark",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "fa fa-check valid-icon icon-right input-icon",
                                      }),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "control-label",
                                          attrs: { for: "remark" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("translate")("t.remark")
                                            )
                                          ),
                                        ]
                                      ),
                                      _c("i", { staticClass: "bar" }),
                                      _c(
                                        "small",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has("remark"),
                                              expression:
                                                "errors.has('remark')",
                                            },
                                          ],
                                          staticClass: "help text-danger",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.errors.first("remark"))
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm.isShowBank
                ? _c(
                    "tab",
                    {
                      attrs: { name: _vm.$t("finance.toBank"), id: "to-bank" },
                    },
                    [
                      _c("form", { staticStyle: { padding: "0 20px 10px" } }, [
                        _c("div", { staticClass: "va-row" }, [
                          _c("div", { staticClass: "flex xs12 md6" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group with-icon-right mb-2",
                                class: {
                                  "has-error": _vm.withdrawCurrencyStatus,
                                  valid:
                                    _vm.isWithdrawCurrencyValid(
                                      "withdrawCurrency"
                                    ),
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "input-group" },
                                  [
                                    _c("vuestic-kyc-select", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'",
                                        },
                                      ],
                                      staticClass: "withdraw-to-bank",
                                      attrs: {
                                        name: "withdrawCurrency",
                                        "data-vv-as": "Settlement Currency",
                                        required: "",
                                        label:
                                          _vm.$t(
                                            "kyc.financial_infomation.settlement_currency"
                                          ) + "：",
                                        options:
                                          _vm.withdrawToBankCurrencyOption,
                                        "option-key": "label",
                                        autocomplete: "off",
                                      },
                                      on: {
                                        input: (val) => {
                                          _vm.withdrawCurrencyStatus = !val
                                            ? true
                                            : false
                                          _vm.withdrawCurrencyChange(val)
                                        },
                                      },
                                      model: {
                                        value: _vm.withdrawCurrency,
                                        callback: function ($$v) {
                                          _vm.withdrawCurrency = $$v
                                        },
                                        expression: "withdrawCurrency",
                                      },
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                    }),
                                    _c("i", {
                                      staticClass: "fa icon-right input-icon",
                                    }),
                                    _c(
                                      "small",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.withdrawCurrencyStatus,
                                            expression:
                                              "withdrawCurrencyStatus",
                                          },
                                        ],
                                        staticClass: "help text-danger",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "finance.theSettlementCurrencyFieldIsRequired"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]),
                          _vm.withdrawCurrency && _vm.isUSDEUR
                            ? _c("div", { staticClass: "flex xs12 md6" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group with-icon-right mb-2",
                                    class: {
                                      "has-error": _vm.withdrawToBankStatus,
                                      valid:
                                        _vm.isWithdrawToBankValid(
                                          "withdrawToBank"
                                        ),
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group" },
                                      [
                                        _c("vuestic-kyc-select", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'",
                                            },
                                          ],
                                          staticClass: "withdraw-to-bank",
                                          attrs: {
                                            name: "withdrawToBank",
                                            "data-vv-as":
                                              "Settlement Bank Account",
                                            required: "",
                                            label:
                                              _vm.$t(
                                                "finance.settlementBankAccount"
                                              ) + "：",
                                            options: _vm.withdrawToBankOption,
                                            "option-key": "label",
                                            autocomplete: "off",
                                          },
                                          on: {
                                            input: (val) => {
                                              _vm.withdrawToBankStatus = !val
                                                ? true
                                                : false
                                              _vm.withdrawToBankChange(val)
                                            },
                                          },
                                          model: {
                                            value: _vm.withdrawToBank,
                                            callback: function ($$v) {
                                              _vm.withdrawToBank = $$v
                                            },
                                            expression: "withdrawToBank",
                                          },
                                        }),
                                        _c("i", {
                                          staticClass:
                                            "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                        }),
                                        _c("i", {
                                          staticClass:
                                            "fa icon-right input-icon",
                                        }),
                                        _c(
                                          "small",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.withdrawToBankStatus,
                                                expression:
                                                  "withdrawToBankStatus",
                                              },
                                            ],
                                            staticClass: "help text-danger",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "finance.theSettlementBankAccountFieldIsRequired"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm.withdrawCurrency
                          ? _c(
                              "div",
                              [
                                _vm.withdrawToBank
                                  ? _c("div", { staticClass: "va-row" }, [
                                      _c(
                                        "div",
                                        { staticClass: "flex xs12 md4" },
                                        [
                                          _c("span", [_vm._v("Currency：")]),
                                          _c(
                                            "b",
                                            {
                                              staticStyle: {
                                                "word-break": "break-all",
                                                "font-weight": "bold",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.accountInfo.currency
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "flex xs12 md4" },
                                        [
                                          _c("span", [
                                            _vm._v("Account Number："),
                                          ]),
                                          _c(
                                            "b",
                                            {
                                              staticStyle: {
                                                "word-break": "break-all",
                                                "font-weight": "bold",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.accountInfo
                                                      .account_number
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "flex xs12 md4" },
                                        [
                                          _c("span", [
                                            _vm._v("Account Name："),
                                          ]),
                                          _c(
                                            "b",
                                            {
                                              staticStyle: {
                                                "word-break": "break-all",
                                                "font-weight": "bold",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.accountInfo.account_name
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "flex xs12 md4" },
                                        [
                                          _c("span", [_vm._v("Bank Name：")]),
                                          _c(
                                            "b",
                                            {
                                              staticStyle: {
                                                "word-break": "break-all",
                                                "font-weight": "bold",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.accountInfo.bank_name
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "flex xs12 md4" },
                                        [
                                          _c("span", [_vm._v("Country：")]),
                                          _c(
                                            "b",
                                            {
                                              staticStyle: {
                                                "word-break": "break-all",
                                                "font-weight": "bold",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.accountInfo.country
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "flex xs12 md4" },
                                        [
                                          _c("span", [_vm._v("Branch：")]),
                                          _c(
                                            "b",
                                            {
                                              staticStyle: {
                                                "word-break": "break-all",
                                                "font-weight": "bold",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.accountInfo.branch
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "flex xs12 md4" },
                                        [
                                          _c("span", [_vm._v("SWIFT：")]),
                                          _c(
                                            "b",
                                            {
                                              staticStyle: {
                                                "word-break": "break-all",
                                                "font-weight": "bold",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.accountInfo.swift_code
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "flex xs12 md4" },
                                        [
                                          _c("span", [_vm._v("Address：")]),
                                          _c(
                                            "b",
                                            {
                                              staticStyle: {
                                                "word-break": "break-all",
                                                "font-weight": "bold",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.accountInfo.address
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "flex xs12 md4" },
                                        [
                                          _c("span", [_vm._v("IBAN：")]),
                                          _c(
                                            "b",
                                            {
                                              staticStyle: {
                                                "word-break": "break-all",
                                                "font-weight": "bold",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.accountInfo.iban) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._l(
                                  _vm.bankWithdrawData,
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      { key: index, staticClass: "va-row" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "flex xs12 md3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-group with-icon-right",
                                                class: {
                                                  "has-error":
                                                    item[
                                                      `bankCurrencyStatus${index}`
                                                    ],
                                                  valid:
                                                    _vm.isBankCurrencyValid(
                                                      item
                                                    ),
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "input-group",
                                                  },
                                                  [
                                                    _c("vuestic-kyc-select", {
                                                      directives: [
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: "required",
                                                          expression:
                                                            "'required'",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "withdraw-tobank-currency",
                                                      attrs: {
                                                        name: `Currency ${index}：`,
                                                        "data-vv-as": `Currency ${index}：`,
                                                        required: "",
                                                        label:
                                                          _vm.$t("t.currency") +
                                                          "：",
                                                        "option-key": "label",
                                                        options:
                                                          _vm.newCurrencies,
                                                        autocomplete: "off",
                                                      },
                                                      on: {
                                                        input: (val) => {
                                                          item[
                                                            `bankCurrencyStatus${index}`
                                                          ] = !val
                                                            ? true
                                                            : false
                                                          item["balance"] =
                                                            val.balance
                                                          // $validator.validate(`bankAmountWithdraw${index}`);
                                                        },
                                                      },
                                                      model: {
                                                        value: item["currency"],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "currency",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item['currency']",
                                                      },
                                                    }),
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                                    }),
                                                    _c("i", {
                                                      staticClass:
                                                        "fa icon-right input-icon",
                                                    }),
                                                    item[
                                                      `bankCurrencyStatus${index}`
                                                    ]
                                                      ? _c(
                                                          "small",
                                                          {
                                                            staticClass:
                                                              "help text-danger",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "The Currency " +
                                                                _vm._s(
                                                                  index + 1
                                                                ) +
                                                                " field is required."
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "flex xs12 md2" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-group with-icon-right",
                                                staticStyle: {
                                                  "padding-top": "8px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "input-group",
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            item["balance"],
                                                          expression:
                                                            "item['balance']",
                                                        },
                                                      ],
                                                      attrs: {
                                                        name: "Balance",
                                                        "data-vv-as": "Balance",
                                                        autocomplete: "off",
                                                        disabled: true,
                                                      },
                                                      domProps: {
                                                        value: item["balance"],
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            item,
                                                            "balance",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                                    }),
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-check valid-icon icon-right input-icon",
                                                    }),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "control-label",
                                                        attrs: {
                                                          for: "bank-balance",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("t.balance")
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c("i", {
                                                      staticClass: "bar",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "flex xs12 md4" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-group with-icon-right",
                                                class: {
                                                  "has-error": _vm.errors.has(
                                                    `bankAmountWithdraw${index}`
                                                  ),
                                                  valid: _vm.isFormFieldValid(
                                                    `bankAmountWithdraw${index}`
                                                  ),
                                                },
                                                staticStyle: {
                                                  "padding-top": "8px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "input-group",
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: item["amount"],
                                                          expression:
                                                            "item['amount']",
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: `required|verifyWithdrawAmount:${index}`,
                                                          expression:
                                                            "`required|verifyWithdrawAmount:${index}`",
                                                        },
                                                      ],
                                                      attrs: {
                                                        name: `bankAmountWithdraw${index}`,
                                                        "data-vv-as": `Amount for Withdrawal ${
                                                          index + 1
                                                        }`,
                                                        autocomplete: "off",
                                                        type: "text",
                                                        required: "",
                                                        oninput:
                                                          "if(!value){value=''}else if(value.charAt(0)==='0'&&value.charAt(1)&&value.charAt(1)!=='.'){value='0'};value = value.replace(/[^\\d.]/g, '');value=value.replace(/\\.{2,}/g, '.');value=value.match(/^\\d*(\\.?\\d{0,2})/g)[0] || '';",
                                                      },
                                                      domProps: {
                                                        value: item["amount"],
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            item,
                                                            "amount",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                                    }),
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-check valid-icon icon-right input-icon",
                                                    }),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "control-label",
                                                        attrs: {
                                                          for: "bankAmountWithdraw",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "finance.amountForWithdrawal"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c("i", {
                                                      staticClass: "bar",
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm.errors.has(
                                                                `bankAmountWithdraw${index}`
                                                              ),
                                                            expression:
                                                              "errors.has(`bankAmountWithdraw${index}`)",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "help text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.errors.first(
                                                              `bankAmountWithdraw${index}`
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm.isUSDEUR
                                          ? _c(
                                              "div",
                                              { staticClass: "flex xs12 md3" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group with-icon-right",
                                                    staticStyle: {
                                                      "padding-top": "8px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group",
                                                      },
                                                      [
                                                        _vm.bankWithdrawData
                                                          .length -
                                                          1 ===
                                                        index
                                                          ? _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "btn btn-primary btn-micro",
                                                                staticStyle: {
                                                                  "margin-right":
                                                                    "10px",
                                                                },
                                                                attrs: {
                                                                  type: "button",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.addBankCurrency(
                                                                        index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "fa fa-plus",
                                                                }),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm.bankWithdrawData
                                                          .length > 1
                                                          ? _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "btn btn-primary btn-micro",
                                                                attrs: {
                                                                  type: "button",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.minusBankCurrency(
                                                                        index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "fa fa-minus",
                                                                }),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  }
                                ),
                                _c("div", { staticClass: "va-row" }, [
                                  _c("div", { staticClass: "flex xs12 md12" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group with-icon-right",
                                        class: {
                                          "has-error":
                                            _vm.errors.has("bankRemark"),
                                          valid:
                                            _vm.isFormFieldValid("bankRemark"),
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c("textarea", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.bankRemark,
                                                  expression: "bankRemark",
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'",
                                                },
                                              ],
                                              attrs: {
                                                name: "bankRemark",
                                                "data-vv-as": "BankRemark",
                                                autocomplete: "off",
                                                maxlength: "200",
                                                required: "",
                                              },
                                              domProps: {
                                                value: _vm.bankRemark,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.bankRemark =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-check valid-icon icon-right input-icon",
                                            }),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "control-label",
                                                attrs: { for: "bankRemark" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("translate")(
                                                      "t.remark"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c("i", { staticClass: "bar" }),
                                            _c(
                                              "small",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.errors.has(
                                                        "bankRemark"
                                                      ),
                                                    expression:
                                                      "errors.has('bankRemark')",
                                                  },
                                                ],
                                                staticClass: "help text-danger",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "bankRemark"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm.isShowVA
                ? _c(
                    "tab",
                    {
                      attrs: {
                        name: _vm.$t("finance.toVAWallet"),
                        id: "to-va-wallet",
                      },
                    },
                    [
                      _c(
                        "form",
                        { staticStyle: { padding: "10px 20px" } },
                        [
                          _c("div", { staticClass: "va-row" }, [
                            _c("div", { staticClass: "flex xs12 md6" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "form-group with-icon-right mb-2",
                                  class: {
                                    "has-error":
                                      _vm.errors.has("virtualAccount"),
                                    valid:
                                      _vm.isFormFieldValid("virtualAccount"),
                                  },
                                },
                                [
                                  _c("div", { staticClass: "input-group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.virtualAccount,
                                          expression: "virtualAccount",
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'",
                                        },
                                      ],
                                      attrs: {
                                        name: "virtualAccount",
                                        "data-vv-as": "VA Wallet Address",
                                        autocomplete: "off",
                                        type: "text",
                                        required: "",
                                        onkeyup:
                                          "value=value.replace(/\\s/g,'')",
                                        onkeydown:
                                          "value=value.replace(/\\s/g,'')",
                                      },
                                      domProps: { value: _vm.virtualAccount },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.virtualAccount =
                                            $event.target.value
                                        },
                                      },
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-check valid-icon icon-right input-icon",
                                    }),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "control-label",
                                        attrs: { for: "virtualAccount" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("finance.vaWalletAddress")
                                          )
                                        ),
                                      ]
                                    ),
                                    _c("i", { staticClass: "bar" }),
                                    _c(
                                      "small",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.errors.has("virtualAccount"),
                                            expression:
                                              "errors.has('virtualAccount')",
                                          },
                                        ],
                                        staticClass: "help text-danger",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errors.first("virtualAccount")
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._l(
                            _vm.virtualAccountData,
                            function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "va-row" },
                                [
                                  _c("div", { staticClass: "flex xs12 md3" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group with-icon-right",
                                        class: {
                                          "has-error":
                                            item[
                                              `accountCurrencyStatus${index}`
                                            ],
                                          valid:
                                            _vm.isAccountCurrencyValid(item),
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c("vuestic-kyc-select", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'",
                                                },
                                              ],
                                              staticClass:
                                                "withdraw-tobank-currency",
                                              attrs: {
                                                name: `Currency ${index}：`,
                                                "data-vv-as": `Currency ${index}：`,
                                                required: "",
                                                label:
                                                  _vm.$t("t.currency") + "：",
                                                "option-key": "label",
                                                options:
                                                  _vm.newAccountCurrencies,
                                                autocomplete: "off",
                                              },
                                              on: {
                                                input: (val) => {
                                                  item[
                                                    `accountCurrencyStatus${index}`
                                                  ] = !val ? true : false
                                                  item["balance"] = val.balance
                                                  // $validator.validate(`accountAmountWithdraw${index}`);
                                                },
                                              },
                                              model: {
                                                value: item["currency"],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "currency",
                                                    $$v
                                                  )
                                                },
                                                expression: "item['currency']",
                                              },
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa icon-right input-icon",
                                            }),
                                            item[
                                              `accountCurrencyStatus${index}`
                                            ]
                                              ? _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "help text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "The Currency " +
                                                        _vm._s(index + 1) +
                                                        " field is required."
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "flex xs12 md2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group with-icon-right",
                                        staticStyle: { "padding-top": "8px" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: item["balance"],
                                                  expression: "item['balance']",
                                                },
                                              ],
                                              attrs: {
                                                name: "Balance",
                                                "data-vv-as": "Balance",
                                                autocomplete: "off",
                                                disabled: true,
                                              },
                                              domProps: {
                                                value: item["balance"],
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    item,
                                                    "balance",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-check valid-icon icon-right input-icon",
                                            }),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "control-label",
                                                attrs: { for: "bank-balance" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("t.balance"))
                                                ),
                                              ]
                                            ),
                                            _c("i", { staticClass: "bar" }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "flex xs12 md4" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group with-icon-right",
                                        class: {
                                          "has-error": _vm.errors.has(
                                            `accountAmountWithdraw${index}`
                                          ),
                                          valid: _vm.isFormFieldValid(
                                            `accountAmountWithdraw${index}`
                                          ),
                                        },
                                        staticStyle: { "padding-top": "8px" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: item["amount"],
                                                  expression: "item['amount']",
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: `required|verifyVAWithdrawAmount:${index}`,
                                                  expression:
                                                    "`required|verifyVAWithdrawAmount:${index}`",
                                                },
                                              ],
                                              attrs: {
                                                name: `accountAmountWithdraw${index}`,
                                                "data-vv-as": `Amount for Withdrawal ${
                                                  index + 1
                                                }`,
                                                autocomplete: "off",
                                                type: "text",
                                                required: "",
                                                oninput:
                                                  "if(!value){value=''}else if(value.charAt(0)==='0'&&value.charAt(1)&&value.charAt(1)!=='.'){value='0'};value = value.replace(/[^\\d.]/g, '');value=value.replace(/\\.{2,}/g, '.');value=value.match(/^\\d*(\\.?\\d{0,2})/g)[0] || '';",
                                              },
                                              domProps: {
                                                value: item["amount"],
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    item,
                                                    "amount",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-check valid-icon icon-right input-icon",
                                            }),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "control-label",
                                                attrs: {
                                                  for: "accountAmountWithdraw",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "finance.amountForWithdrawal"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c("i", { staticClass: "bar" }),
                                            _c(
                                              "small",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      `accountAmountWithdraw${index}`
                                                    ),
                                                    expression:
                                                      "errors.has(`accountAmountWithdraw${index}`)",
                                                  },
                                                ],
                                                staticClass: "help text-danger",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      `accountAmountWithdraw${index}`
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "flex xs12 md3" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group with-icon-right",
                                        staticStyle: { "padding-top": "8px" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _vm.virtualAccountData.length -
                                              1 ===
                                            index
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btn-micro",
                                                    staticStyle: {
                                                      "margin-right": "10px",
                                                    },
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.addAccountCurrency(
                                                          index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fa fa-plus",
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.virtualAccountData.length > 1
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btn-micro",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.minusAccountCurrency(
                                                          index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-minus",
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              )
                            }
                          ),
                          _c("div", { staticClass: "va-row" }, [
                            _c("div", { staticClass: "flex xs12 md12" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form-group with-icon-right",
                                  class: {
                                    "has-error":
                                      _vm.errors.has("accountRemark"),
                                    valid:
                                      _vm.isFormFieldValid("accountRemark"),
                                  },
                                },
                                [
                                  _c("div", { staticClass: "input-group" }, [
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.accountRemark,
                                          expression: "accountRemark",
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'",
                                        },
                                      ],
                                      attrs: {
                                        name: "accountRemark",
                                        "data-vv-as": "AccountRemark",
                                        autocomplete: "off",
                                        maxlength: "200",
                                        required: "",
                                      },
                                      domProps: { value: _vm.accountRemark },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.accountRemark =
                                            $event.target.value
                                        },
                                      },
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-check valid-icon icon-right input-icon",
                                    }),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "control-label",
                                        attrs: { for: "accountRemark" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("translate")("t.remark")
                                          )
                                        ),
                                      ]
                                    ),
                                    _c("i", { staticClass: "bar" }),
                                    _c(
                                      "small",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.errors.has("accountRemark"),
                                            expression:
                                              "errors.has('accountRemark')",
                                          },
                                        ],
                                        staticClass: "help text-danger",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errors.first("accountRemark")
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                        ],
                        2
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }